import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CCard, CButton, CFormInput } from '@coreui/react'
import AssetManagerNew from '../AssetManager/AssetManagerNew'
import './content.scss'
import '../../../scss/style.scss'
import { isEmpty, raiseToast } from '../../utils/helper'
import useAxios from 'axios-hooks'
import AssetSelectorBox from 'src/components/assetSelectorBox/assetSelectorBox'
import { AppContext } from 'src/views/context/app'
import { LIVE_STREAM_API } from 'src/views/utils/urls'
import Select from 'react-select'

const Upload = (props) => {
  const { toggleValue, isEdit, details, cancelModal } = props

  const dispatch = useDispatch()
  const [showAssetManager, setShowAssetManager] = useState(false)
  // const [uploadDisabled, setUploadDisabled] = useState(false)
  const [assetModalType, setAssetModalType] = useState('')
  const [trailerAsset, setTrailerAsset] = useState({})
  const [contentAsset, setContentAsset] = useState({})
  const [streamUrl, setStreamUrl] = useState('')
  const [liveStreamMaster, setLiveStreamMaster] = useState([])
  const [selectedLiveStream, setSelectedLiveStream] = useState('')
  const [isExternalLive, setIsExternalLive] = useState(false)
  const content = useSelector((state) => state.contentReducer)

  const { accountObj } = useContext(AppContext)

  const [{ data: liveStreamList }, liveStreamListCall] = useAxios(
    {
      url: LIVE_STREAM_API,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    if (accountObj && accountObj.module_permissions.live) {
      liveStreamListCall()
    }
  }, [])

  useEffect(() => {
    if (liveStreamList && liveStreamList.success) {
      setLiveStreamMaster(liveStreamList.data)
    }
  }, [liveStreamList])

  useEffect(() => {
    if (isEdit && !isEmpty(details) && details?.video_type) {
      if (!isEmpty(details?.preview)) {
        setTrailerAsset({ ...details?.preview, asset_id: details?.preview?._id })
      }

      // if (details['video_type'] !== 'LIVE' && !isEmpty(details?.source_asset_id)) {
      if (checkNormalContent(details)) {
        setContentAsset({ ...details?.source_asset_id, asset_id: details?.source_asset_id?._id })
        // } else if (details['video_type'] === 'LIVE' && details?.stream) {
      } else if (checkLiveContent(details)) {
        let isInternal = details['stream']['type'] === 'Internal'
        setIsExternalLive(!isInternal)
        isInternal
          ? setSelectedLiveStream({
              value: details['stream']['link']?._id,
              label: (
                <div className="d-flex align-items-center cursor-pointer">
                  <div
                    style={{
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: details['stream']['link']?.in_progress
                        ? '#2eb914'
                        : '#929292',
                    }}
                  ></div>
                  <span style={{ fontSize: '14px' }} className="d-flex align-items-center mx-2">
                    {details['stream']['link']?.name}
                  </span>
                  <span style={{ fontSize: '14px' }} className="d-flex align-items-center ml-5">
                    ({details['stream']['link']?.in_progress ? 'ONLINE' : 'OFFLINE'})
                  </span>
                </div>
              ),
            })
          : setStreamUrl(details['stream']['link'])
      }
      console.log('details', details)
    }
  }, [isEdit, details])

  const checkNormalContent = (details) => {
    if (isEmpty(details?.source_asset_id)) return false
    if (details['video_type'] === 'IPTV' && details?.iptv_content_type === 'LIVE') return false
    if (details['video_type'] === 'LIVE') return false

    return true
  }

  const checkLiveContent = (details) => {
    if (isEmpty(details?.stream)) return false
    if (details['video_type'] === 'IPTV' && details?.iptv_content_type !== 'LIVE') return false
    if (details['video_type'] !== 'LIVE' && details['video_type'] !== 'IPTV') return false

    return true
  }

  const handleExternalUrl = (value) => {
    if (!isEmpty(selectedLiveStream)) {
      setSelectedLiveStream({})
    }
    setStreamUrl(value)
  }

  const handleInternalUrl = (value) => {
    if (streamUrl) {
      setStreamUrl('')
    }
    setSelectedLiveStream(value)
  }

  const validateInfo = () => {
    let isFormValid = true

    if (content.video_type !== 'LIVE' && content.video_type !== 'IPTV' && isEmpty(contentAsset)) {
      isFormValid = false
      raiseToast('error', 'Please Attach an Asset to Content!')
    }
    if (content.video_type === 'LIVE' && isEmpty(selectedLiveStream) && !streamUrl) {
      isFormValid = false
      raiseToast('error', 'Please Attach an Live Stream to Content!')
    }
    if (content.video_type === 'IPTV') {
      if (content?.iptv_content_type === 'LIVE' && isEmpty(selectedLiveStream) && !streamUrl) {
        isFormValid = false
        raiseToast('error', 'Please Attach an Live Stream to Content!')
      } else if (content?.iptv_content_type !== 'LIVE' && isEmpty(contentAsset)) {
        isFormValid = false
        raiseToast('error', 'Please Attach an Asset to Content!')
      }
    }

    return isFormValid
  }

  const handleSaveNext = () => {
    if (content.video_type === 'MPVP') {
      if (trailerAsset?.asset_id) {
        dispatch({
          type: 'UPLOAD',
          payload: {
            sourceAssetId: '',
            trailerAssetId: trailerAsset?.asset_id,
          },
        })
      }
      toggleValue(3)
      return
    }
    if (validateInfo()) {
      if (
        content.video_type === 'LIVE' ||
        (content.video_type === 'IPTV' && content?.iptv_content_type === 'LIVE')
      ) {
        let link = !isEmpty(selectedLiveStream)
          ? liveStreamMaster.find((item) => item._id === selectedLiveStream?.value)
          : streamUrl
        dispatch({
          type: 'SET_STREAM',
          payload: {
            liveStream: { link: link, type: !isExternalLive ? 'Internal' : 'External' },
            trailerAssetId: trailerAsset?.asset_id ? trailerAsset?.asset_id : '',
          },
        })
      } else {
        dispatch({
          type: 'UPLOAD',
          payload: {
            sourceAssetId: contentAsset.asset_id,
            trailerAssetId: trailerAsset?.asset_id ? trailerAsset?.asset_id : '',
          },
        })
      }

      toggleValue(3)
    }
  }

  const handleAssetSelect = (info) => {
    if (assetModalType === 'TRAILER') {
      setTrailerAsset(info)
    } else {
      setContentAsset(info)
    }
  }
  const openAssetModal = (type) => {
    setAssetModalType(type)
    setShowAssetManager(true)
  }

  const getLiveStreamOptions = () => {
    return liveStreamMaster.map((info) => ({
      value: info?._id,
      label: (
        <div className="d-flex align-items-center cursor-pointer">
          <div
            style={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: info?.in_progress ? '#2eb914' : '#929292',
            }}
          ></div>
          <span style={{ fontSize: '14px' }} className="d-flex align-items-center mx-2">
            {info?.name}
          </span>
          <span style={{ fontSize: '14px' }} className="d-flex align-items-center ml-5">
            ({info?.in_progress ? 'ONLINE' : 'OFFLINE'})
          </span>
        </div>
      ),
    }))
  }

  return (
    <>
      <CCard>
        <div style={{ marginTop: '1.5vw' }} className="  d-flex flex-column align-items-center">
          {content.video_type === 'LIVE' ||
          (content.video_type === 'IPTV' && content?.iptv_content_type === 'LIVE') ? (
            <div style={{ width: '84.4%' }}>
              <div className=" d-flex justify-content-between">
                <p style={{ fontSize: '1.5625vw', fontWeight: '600' }} className="mb-0">
                  ADD STREAMING URL
                </p>
              </div>
              <div style={{ marginTop: '2.448vw' }} className="">
                <div className="d-flex justify-content-start align-items-center">
                  <h5 style={{ fontSize: '0.83vw' }}>Choose URL Type</h5>
                  <div
                    className="mx-5 d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
                    style={{ border: '0.5px solid #707070' }}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: '40px',
                        backgroundColor: isExternalLive ? '#fff' : '#000',
                        color: isExternalLive ? '#000' : '#fff',
                        padding: '8px 26px',
                        cursor: 'pointer',
                      }}
                      onClick={() => setIsExternalLive(false)}
                    >
                      <p
                        style={{
                          marginBlock: '0',
                          fontWeight: !isExternalLive ? '600' : '400',
                        }}
                      >
                        OTTDock Streaming URL
                      </p>
                    </div>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: '40px',
                        color: isExternalLive ? '#fff' : '#000',
                        backgroundColor: isExternalLive ? '#000' : '#fff',
                        padding: '8px 26px',
                        cursor: 'pointer',
                      }}
                      onClick={() => setIsExternalLive(true)}
                    >
                      <p
                        style={{
                          marginBlock: '0',
                          fontWeight: isExternalLive ? '600' : '400',
                        }}
                      >
                        External Streaming URL
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: '2.865vw', width: '53%' }}>
                {!isExternalLive ? (
                  <div style={{ marginBottom: '4.375vw' }}>
                    <Select
                      value={selectedLiveStream}
                      onChange={handleInternalUrl}
                      options={getLiveStreamOptions()}
                      isSearchable={false}
                      placeholder={'Select Live Stream'}
                    />
                  </div>
                ) : (
                  <div style={{ marginBottom: '2.6vw' }}>
                    <CFormInput
                      type="text"
                      placeholder="Enter HLS m3u8 URL"
                      value={streamUrl}
                      onChange={(e) => {
                        handleExternalUrl(e.target.value)
                      }}
                      size="sm"
                    />
                    <p style={{ fontSize: '14px', color: '#515151' }} className="mt-3 mb-0">
                      Sample URL :
                      http://demo.unified-streaming.com/video/tears-of-steel/tears-of-steel.ism/.m3u8
                    </p>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div style={{ width: '84.4%' }} className="">
              <div className=" d-flex justify-content-between">
                <div>
                  <p style={{ fontSize: '1.5625vw', fontWeight: '600' }} className="mb-0">
                    {content.video_type === 'MPVP' ? 'NO CONTENT REQUIRED' : 'SELECT CONTENT'}
                  </p>
                  <p style={{ fontSize: '1vw', fontWeight: '500' }} className="mb-2">
                    {content.video_type === 'MPVP'
                      ? 'No asset addition is applicable for Multi-part Parent Video'
                      : 'Add Content from Asset Manager'}
                  </p>
                </div>
                <p style={{ fontSize: '1vw', color: '#f80606' }}>
                  * Uploading Content is mandatory.
                </p>
              </div>
              <AssetSelectorBox
                data={contentAsset}
                onSelect={() => openAssetModal('CONTENT')}
                onEdit={() => openAssetModal('CONTENT')}
                onDelete={() => setContentAsset({})}
                disabled={content.video_type === 'MPVP'}
              />
              {content.video_type !== 'MPVP' && (
                <p style={{ fontSize: '1vw', color: '#707070' }} className="mb-0 mt-2">
                  Map your publishing Contents here.
                </p>
              )}
            </div>
          )}

          {content.video_type === 'LIVE' ||
          (content.video_type === 'IPTV' && content?.iptv_content_type === 'LIVE') ? (
            <hr style={{ width: '93%', color: '#707070' }} className="" />
          ) : null}
          <div style={{ width: '84.4%' }} className="mt-3">
            <div className=" d-flex justify-content-between">
              <div>
                <p style={{ fontSize: '1.5625vw', fontWeight: '600' }} className="mb-0">
                  {content.video_type === 'IPTV' ? 'NO TRAILER REQUIRED' : 'SELECT TRAILER'}
                  {content.video_type !== 'IPTV' && (
                    <span style={{ fontSize: '1vw', fontWeight: 'normal' }} className="ml-3">
                      (Optional)
                    </span>
                  )}
                </p>
                <p style={{ fontSize: '1vw', fontWeight: '500' }} className="mb-2">
                  {content.video_type === 'IPTV'
                    ? 'No Trailer addition is required for IPTV Content'
                    : 'Add Trailer from Asset Manager'}
                </p>
              </div>
            </div>
            <AssetSelectorBox
              data={trailerAsset}
              onSelect={() => openAssetModal('TRAILER')}
              onEdit={() => openAssetModal('TRAILER')}
              onDelete={() => setTrailerAsset({})}
              disabled={content.video_type === 'IPTV'}
            />
            <p style={{ fontSize: '1vw', color: '#707070' }} className="mb-0 mt-2">
              Map your publishing media trailer/preview here.
            </p>
            <div className=" d-flex justify-content-end pb-3">
              <CButton
                style={{ color: 'black', border: '1px solid #bdbdbd' }}
                className="mx-4 bg-white rounded-1 btn-focus-none"
                onClick={() => cancelModal(true)}
              >
                Cancel
              </CButton>
              <CButton
                style={{ backgroundColor: '#20211c' }}
                className="px-3 rounded-1 btn-focus-none"
                onClick={handleSaveNext}
              >
                Save & Next
              </CButton>
            </div>
          </div>
        </div>
      </CCard>

      {showAssetManager && (
        <AssetManagerNew
          onCancel={() => setShowAssetManager(false)}
          type={assetModalType === 'TRAILER' ? 'TRAILER' : 'VIDEO'}
          setAsset={(info) => {
            handleAssetSelect(info)
            setShowAssetManager(false)
          }}
        />
      )}
    </>
  )
}

export default Upload
